var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPaintbrushIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "paintbrush-icon-foreground",
    d: "M22.1888 31.3895C21.8249 30.4957 21.1605 29.7558 20.3092 29.2964C19.4579 28.8371 18.4729 28.6869 17.5227 28.8717C16.5725 29.0564 15.7164 29.5646 15.1009 30.3091C14.4855 31.0537 14.149 31.9882 14.1491 32.9528C14.1491 33.3798 14.0611 33.8022 13.8905 34.1939C13.7199 34.5856 13.4704 34.9383 13.1574 35.23C12.8444 35.5217 12.4746 35.7462 12.071 35.8897C11.6673 36.0331 11.2384 36.0925 10.8108 36.064C11.4985 37.2544 12.5615 38.1853 13.8346 38.7121C15.1078 39.239 16.5198 39.3323 17.8517 38.9777C19.1835 38.623 20.3606 37.8402 21.2002 36.7508C22.0397 35.6614 22.4948 34.3263 22.4948 32.9528C22.4948 32.3998 22.3863 31.8718 22.1888 31.3895ZM22.1888 31.3895C23.8427 30.8281 25.4245 30.0745 26.9014 29.1444M19.8868 29.1098C20.4504 27.4585 21.2077 25.8792 22.1429 24.4048M26.9 29.1444C29.5378 27.484 31.7955 25.2893 33.5265 22.703L38.9179 14.6456C39.1244 14.3387 39.2176 13.9699 39.1816 13.6022C39.1455 13.2344 38.9825 12.8906 38.7202 12.6293C38.458 12.368 38.1129 12.2056 37.7438 12.1697C37.3747 12.1338 37.0045 12.2266 36.6965 12.4324L28.6095 17.8054C26.0133 19.5296 23.8101 21.7785 22.1429 24.4062C24.2598 25.3492 25.9535 27.0367 26.9 29.1458",
    strokeWidth: 2.11249,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaintbrushIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PaintbrushIcon.b5a32cb380830b45d6d6b9c3589ea873.svg";